<div
  (click)="onContainerClicked($event)"
  class="basic modal fade"
  tabindex="-1"
  [ngClass]="{ in: visibleAnimate }"
  [ngStyle]="{
    display: visible ? 'block' : 'none',
    opacity: visibleAnimate ? 1 : 0
  }"
>
  <div class="modal-dialog" [ngClass]="dialogClass">
    <div class="modal-content">
      <div *ngIf="!hideHeader" class="modal-header">
        <button class="btn btn-outline-primary btn-icon" (click)="hide()">
          <i class="icofont icofont-close-circled" style="margin: auto"></i>
        </button>
      </div>
      <div class="modal-body">
        <voter-list
          [discussion]="discussion"
          [limit]="limit"
          [config]="config"
          (hide)="hide()"
        >
        </voter-list>
      </div>
      <div *ngIf="!hideFooter" class="modal-footer"></div>
    </div>
  </div>
</div>
